import {ThemeProvider} from 'styled-components'
import {useLocation} from 'react-router-dom'
import 'react-modern-drawer/dist/index.css'
import 'react-datepicker/dist/react-datepicker.css'
import theme from './theme'
import ResetStyle from './theme/reset'
import './theme/font.css'

import Style from './style'
import AlertModal from './ui/AlertModal'
import ConfirmModal from './ui/ConfirmModal'
import Spinner from './ui/Spinner'
import Header from './ui/Header'
import Aside from './ui/Aside'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import useSpinnerAtom from 'shared/model/useSpinnerAtom'

import Router from 'page'
import {useEffect} from 'react'
import useGetVersion from 'entity/admin/useGetVersion'

const App = () => {
	const {pathname} = useLocation()
	const [versionData] = useGetVersion()

	const [isAlertModalView] = useAlertModalAtom()
	const [isConfrimModalView] = useConfirmModalAtom()
	const [isSpinnerView] = useSpinnerAtom()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	return (
		<ThemeProvider theme={theme}>
			<ResetStyle />

			{isAlertModalView && <AlertModal />}
			{isConfrimModalView && <ConfirmModal />}
			{isSpinnerView && <Spinner />}

			{pathname.startsWith('/event/timer-preview') ? (
				<Router />
			) : (
				<Style.Wrapper>
					<Header versionData={versionData} />
					<Style.ContentWrapper>
						<Aside versionData={versionData} />
						<Router />
					</Style.ContentWrapper>
				</Style.Wrapper>
			)}
		</ThemeProvider>
	)
}

export default App
